/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Filled Star Icon component.
 */
export const MaterialFilledStarIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M9.875 6.35352L14 6.70312L10.8682 9.41699L11.8086 13.4502L8.26367 11.3096L4.71777 13.4502L5.6582 9.41699L2.52637 6.70312L6.65137 6.35352L8.26367 2.5498L9.875 6.35352Z' fill={iconColor} />
    </svg>
  );
};

export default MaterialFilledStarIcon;
